module.exports = __webpack_public_path__ + "static/media/female_back_grey.96133711.png";